import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import About from './pages/About';
import Contact from './pages/Contact';
import CustomerArea from './pages/CustomerArea';
import 'leaflet/dist/leaflet.css';
// Thème MUI personnalisé (bleu pour la confiance)
const theme = createTheme({
  palette: {
    primary: { main: '#1976d2' }, // Bleu
    secondary: { main: '#4caf50' }, // Vert pour écologie
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
            <Route path="/customer-area" element={<CustomerArea />} />
        </Routes>
        <Footer />
      </Router>
    </ThemeProvider>
  );
}

export default App;